<template>
  <div class="content-wrapper">
    <div class="mt-2">
      <div class="row justify-content-between align-items-center py-1">
        <div class="col-12 col-md-6 d-flex align-items-center" style="border-left: 1px solid black">
          <span>Complete the document:
            <span class="ml-2" style="font-weight: 600">{{ document.name }}</span></span>
        </div>
        <div v-if="!filled" class="col-12 col-md-6 breadcrumb-side-button">
          <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
            <app-submit-button label="Submit" @click="submit" :loading="saving" />
          </div>
        </div>
        <app-button v-if="filled && document.completed" :label="'Download'" class-name="btn-primary mr-2"
          @submit="downloadDocument" />
      </div>

      <!-- <div class="d-lg-none" v-if="isMobile">
        <div class="pt-1">
          <h5 class="mt-2">Standard fields</h5>
        </div>
        <ul>
          <li v-for="field in fields">
            {{ field.name }}
            <span class="page-index" @click="scrollTo(field.id)">page: {{ field.page }}</span>
          </li>
        </ul>
      </div> -->
      <div class="d-flex align-items-center mt-2 py-1"
        style="border-bottom: 1px solid rgb(214, 214, 214); background-color: #e9e9e9">
        <div class="border_right py-2 px-2 ml-auto mr-auto">
          <span class="cursor-pointer mr-2" @click="() => onAdd()">
            <i class="fa fa-search-plus fa-rotate-90" aria-hidden="true"> </i>
          </span>
          <span class="cursor-pointer ml-2" @click="() => onSubtrack()">
            <i class="fa fa-search-minus" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div :class="{ 'col-lg-9': !filled }" class="col-12 container_wrap doc-scrollbar">
        <div class="d-flex justify-content-center" id="pdf_container" :class="{ 'loading-opacity': preloader }">
          <app-overlay-loader v-if="preloader" />
          <div v-for="(page, index) in pages" :id="'wrap-' + index + 1" :key="index" class="position-relative">
            <canvas v-once :ref="page.id" :id="page.id"></canvas>

            <DragElmt v-for="t in elements[page.id]" :key="t.id" v-if="!filled" :el="t" :custom-mode="false"
              :document="document" :recipient="recipient" @on-selected="(_) => { }" />

            <div v-if="index > 0" :style="{ height: '20px' }"></div>
          </div>
        </div>
      </div>

      <div v-if="!filled" class="col-12 col-lg-3 d-none d-lg-block lefter h-100">
        <div class="pt-1">
          <h5 class="mt-2">Standard fields</h5>
        </div>
        <ul>
          <li v-for="field in fields">
            {{ field.name }}
            <span class="page-index" @click="scrollTo(field.id)">page: {{ field.page }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { FILL_DOCUMENT } from "../../../../Config/ApiUrl";
import DragElmt from "../components/Drag/Drag.vue";

export default {
  name: "Customizer",
  mixins: [FormMixin],
  components: {
    DragElmt,
  },

  props: {
    document: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array | String,
      required: true,
    },
    recipient: {
      type: Number,
      required: true,
    },
    filled: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    const self = this;
    if (!this.filled) {
      this.fields.forEach((field) => {
        let value = field.value;
        if (field.type === "date" && !this.filled) {
          value = JSON.parse(field.value);
          this.dateFormat.date = `${value[2]}`;
          this.dateFormat.datetime12 = `${value[2]} h:mm A`;
          this.dateFormat.datetime24 = `${value[2]} HH:mm`;
        }

        const [font, size, color, width, height, auto_expand] = field.style.split(":");
        if (this.elements["pdf-" + field.page])
          this.elements["pdf-" + field.page].push({
            ...field,
            font,
            size,
            width: width ?? 80,
            height: height ?? 70,
            auto_expand: parseInt(auto_expand),

            color,
            scale: 1,
            value,
          });
        else
          this.elements["pdf-" + field.page] = [
            {
              ...field,
              font,
              size,
              color,
              auto_expand: parseInt(auto_expand),

              width: width ?? 80,
              height: height ?? 70,
              scale: 1,
              value,
            },
          ];
      });
    }
    setTimeout(() => {
      const pdfjsLib = window["pdfjs-dist/build/pdf"];
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js";
      let pdfDoc = null;

      function LoadPdfFromUrl(url) {
        const isMobile = window.matchMedia("(max-width: 992px)").matches;
        if (isMobile) self.scale -= 0.25;
        document.body.style.overflow = "hidden";
        pdfjsLib.getDocument(url).promise.then(function (pdfDoc_) {
          pdfDoc = pdfDoc_;
          self.pdfDoc = pdfDoc_;
          for (let i = 1; i <= pdfDoc.numPages; i++) {
            const id = "pdf-" + i;
            self.loading.push(false);
            self.pages.push({ id });
            self.RenderPage(i, id, self, isMobile ? false : null);
          }
          self.preloader = false;
        });
      }
      LoadPdfFromUrl(self.document.link);
    }, 5000);
  },
  data() {
    return {
      dateFormat: {
        time12: "h:mm A",
        time24: "HH:mm",
      },
      baseWidth: 0,
      baseHeight: 0,
      isMobile: false,
      scale: 1,
      resolution: 1,
      pagesMeta: [],
      saving: false,
      preloader: true,

      elements: [],
      showPending: false,
      pages: [],
      loading: [],
    };
  },

  methods: {
    RenderPage(num, id, self, isScalling = null) {
      self.pdfDoc.getPage(num).then(function (page) {
        let viewport = page.getViewport({ scale: self.scale });
        if (
          viewport.width > document.getElementById("pdf_container").clientWidth &&
          !window.matchMedia("(max-width: 992px)").matches
        ) {
          this.scale -= 0.25;
          return false;
        }
        self.$refs[id][0].width = self.resolution * viewport.width;
        self.$refs[id][0].height = self.resolution * viewport.height;
        self.pagesMeta[id] = {
          baseWidth: self.resolution * viewport.width,
          baseHeight: self.resolution * viewport.height,
        };

        let ctx = self.$refs[id][0].getContext("2d");
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport,
          transform: [self.resolution, 0, 0, self.resolution, 0, 0],
        };
        page.render(renderContext);

        if (self.elements[id]) {
          self.elements = {
            ...self.elements,
            [id]: self.elements[id].map((rec) => {
              return {
                ...rec,
                scale: self.scale,
                baseWidth: self.resolution * viewport.width,
                baseHeight: self.resolution * viewport.height,
              };
            }),
          };
          if (isScalling !== null) {
            const previousScale = isScalling ? self.scale - 0.25 : self.scale + 0.25;
            let recViewport = page.getViewport({ scale: previousScale });
            self.elements = {
              ...self.elements,
              [id]: self.elements[id].map((rec) => {
                return {
                  ...rec,
                  scale: self.scale,
                  left: rec.left * (viewport.width / recViewport.width),
                  top: rec.top * (viewport.height / recViewport.height),
                };
              }),
            };
          }
        } else {
          self.baseWidth = viewport.width;
          self.baseHeight = viewport.height;
        }
      });
    },
    downloadDocument() {
      window.open(this.document.link, "_blank");
    },
    submit() {
      this.saving = true;
      let canSubmit = true;
      let data = {
        pdf: this.document?.id,
        recipient: this.recipient,
        fields: [],
      };
      console.log(this.elements, this.pagesMeta);
      for (let index = 0; index < Object.values(this.elements).length; index++) {
        const element = Object.values(this.elements)[index];
        element.forEach(({ id, value, type, required, ...rest }) => {
          const parsedValue =
            type === "date" &&
              typeof value === "object" &&
              value !== null &&
              value !== undefined
              ? moment.utc().format(this.dateFormat[value[1]])
              : value;

          if (required && !!!parsedValue) {
            canSubmit = false;
            this.$toastr.e("Please fill in required fields (starred fields)");
            this.saving = false;
          }
          data.fields.push({
            required,
            type:
              type === "date" && typeof value === "object" && value === null
                ? "input"
                : type,
            id,
            value: parsedValue,
          });
        });
      }
      if (canSubmit) {
        this.axiosPost({
          url: FILL_DOCUMENT,
          data,
        })
          .then(() => {
            localStorage.removeItem("signature");
            this.$toastr.s("Operation success !");
            window.location.reload();

            // setTimeout(() => {
            // }, 20000);
          })
          .catch((error) => {
            if (error.response.data && error.response.data.message) {
              this.$toastr.e(error.response.data.message);
            } else {
              this.$toastr.e("Something went wrong");
            }
          })
          .finally(() => (this.saving = false));
      }
    },
    scrollTo(id) {
      document
        .getElementById(id)
        .querySelector(".input-def")
        .scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    },
    onAdd() {
      if (this.preloader) return;
      this.preloader = true;
      this.scale += 0.25;
      for (let i = 1; i <= this.pdfDoc.numPages; i++) {
        const id = "pdf-" + i;
        this.RenderPage(i, id, this, true);
      }
      this.preloader = false;
    },

    onSubtrack() {
      if (this.scale - 0.25 > 0.25 && !this.preloader) {
        this.preloader = true;

        this.scale -= 0.25;
        for (let i = 1; i <= this.pdfDoc.numPages; i++) {
          const id = "pdf-" + i;
          this.RenderPage(i, id, this, false);
        }
        this.preloader = false;
      }
    },
  },
};
</script>

<style scoped>
.doc-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.doc-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.doc-scrollbar::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 5px;
}

.doc-scrollbar:hover::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb-color);
}

.doc-scrollbar:hover::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-thumb-hover-color);
}

#pdf_container {
  background-color: aliceblue;
  flex-direction: column;
  align-items: center;
  /* display: flex;
  
    justify-content: center; */
}

.lefter {
  overflow: auto;
  height: 100vh;
}

.overlap {
  cursor: pointer;
  position: absolute;
}

.replies {
  margin-left: 35px;
}

.overlap_img {
  width: 30px;
  height: 30px;
}

.large_img {
  width: 100%;
  height: auto;
}

.main_comment {
  margin-top: 8px;
  overflow: hidden;
  white-space: pre-wrap;
  word-wrap: break-word;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
  cursor: text;
  padding: 0 12px 0 52px;
}

.page-index {
  color: #4466f2;
  cursor: pointer;
}

.card_tap {
  overflow: hidden;
  outline: none;
  box-shadow: 0 4px 16px #868e963d, 0 0 4px 0 #868e96;
  user-select: none;
  padding: 12px;
  border: none;
  display: block;
  text-align: left;
  border-radius: 4px;
  margin-bottom: 8px;
  margin-left: 2px;
  background: #fff;
  cursor: pointer;
}

.st0 {
  fill: #abb0c4;
}

.card_tap.active .replies,
.card_tap.active .hide_form {
  display: none;
}

.NoteHeader {
  padding-right: 12px;
  position: relative;
  flex: 1;
  color: #485056;
  display: flex;
}

.NoteHeader .author-and-date {
  padding-left: 0;
  padding-top: 0;
  font-size: 10px;
  flex: 1;
  min-width: 0;
  position: relative;
}

.NoteHeader .author-and-time {
  display: flex;
  flex-direction: column;
  word-break: break-word;
}

.NoteHeader .state-and-overflow {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.date-and-time {
  opacity: 0.8;
  font-size: 10px;
  color: #868e96;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item:hover {
  background-color: whitesmoke;
}

.NoteHeader .note-popup-toggle-trigger {
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 20px;
  height: 20px;
}

.replay {
  padding-left: 12px;
  padding-bottom: 24px;
  border-left: 1px solid #a4a4a4;
}

.replay .wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: left;
  flex: 1;
  color: #485056;
  padding-bottom: 0;
}

.replay_container {
  border-top: 1px solid #cfd4da;
  font-size: 13px;
  color: #485056;
}

.container_wrap {
  overflow: overlay;
  max-height: 840px;
}

@media (max-width: 992px) {
  #pdf_container {
    align-items: unset;
  }
}
</style>
